import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface StarProps {
    className?: string
}

/** The eight point Elio star used between marquee items. */
const Star: FC<StarProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            aria-hidden='true'
            className={cn('size-[0.6em] shrink-0', className)}
            fill='currentColor'
        >
            <path d='M12 0l1.9 7.4L19.8 4.2l-3.2 5.9L24 12l-7.4 1.9 3.2 5.9-5.9-3.2L12 24l-1.9-7.4-5.9 3.2 3.2-5.9L0 12l7.4-1.9-3.2-5.9 5.9 3.2z' />
        </svg>
    )
}

export default Star
